import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';
import { sendFSKPostViewAnalytic } from '../sendFSKPostViewAnalytic';

export function runApp() {
  const context = createContext();
  const store = createApplicationState(context);

  renderApplication({ store, context });

  /**
   * При показе страницы
   * Отправляет пост вью аналитику для ФСК
   */
  sendFSKPostViewAnalytic(store);
}
